import './index.css'

import { menuToggle } from '../components/menuToggle'
import { scrollToSection } from '../components/scrollToSection'
import { loadProducts } from '../components/loadProducts'
import { initSetry } from "../utils/sentry";

initSetry()
menuToggle()
scrollToSection()

document.addEventListener("DOMContentLoaded", loadProducts);
